import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import "./features.css";

class Features extends Component {
  render() {
    return (
      <React.Fragment>
        <section className="section" id="features">
          <Container>
            <Row className="align-items-center">
              <Col lg="5" className="order-2 order-lg-1">
                <div className="features-cont">
                  <h3>
                  A modern payroll solution designed for efficiency
                  </h3>
                  <ul className="mt-4 features-item-list">
                    <li>Simplify payroll management and tax calculations</li>
                    <li>
                    Reduce errors and ensure compliance effortlessly
                    </li>
                    <li>Fetch and Categorize Bank Transactions</li>
                    <li>Manage Products and Track Invoices</li>
                    <li>Write and Print your own Checks</li>
                  </ul>
                
                    
                 
                </div>
              </Col>
              <Col lg={{ size: 7, order: 2 }} xs={{ order: 1 }}>
                <div className="features-img mx-auto me-lg-0">
                  <img
                    src="assets/images/growth-analytics.svg"
                    alt="macbook"
                    className="img-fluid"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Features;
